const Videos = function() {
    return {
        initFirstView: function(videos_as_gallery = false) {
            if (typeof Videos.firstViewPlayers == 'undefined') {
                Videos.firstViewPlayers = [];
            }
            const playerId = videos_as_gallery ? Generic.firstview_gallery_player_id : Generic.firstview_player_id;
            $('.ii__firstview_video').each(function() {
                const elem = $(this),
                    elem_id = elem.attr('id'),
                    media_id = elem.data('media_id')
                ;
                if (Videos.firstViewPlayers.includes(elem_id)) {
                    return true; // continue
                }
                Videos.firstViewPlayers.push(elem_id);
                (new Image()).src = `https://capi.connatix.com/tr/si?token=${playerId}&cid=${Generic.firstview_customer_id}`;
                let config = {
                    playerId: playerId,
                    mediaId: media_id,
                    // don't use cnx.configEnums because they load async and might not be available
                    settings: {
                        'playbackMode': 2, // ClickToPlay,
                        'customization': {
                            'floating': {
                                'mode': 0 // Off
                            }
                        }
                    }
                };
                if (videos_as_gallery) {
                    config.playlistId = Generic.firstview_gallery_playlist_id;
                }
                window.cnx.cmd.push(function() {
                    window.cnx(config).render(elem_id);
                });
            });
        },
        initHandlers: function() {
            $('.video-overlay-trigger').off().click(function() {
                window.location.hash = $(this).data('vid');
                Ajax.getVideoModal($(this).data('vid'), function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('body').addClass('video-overlay-on');
                        $('#video-modal-container').html(res.html);
                        Videos.initHandlers();
                    }
                });
            });
            Videos.initFirstView();
        },
        init: function(hash_on_close = '') {
            Videos.initHandlers();
            if (Generic.mobile) {
                $('.carousel--video').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false
                });
            } else {
                $('.carousel--video').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    autoplay: false
                });
            }
            if (window.location.hash &&
                window.location.hash.substring(1)) {
                Ajax.getVideoModal(window.location.hash.substring(1), function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('body').addClass('video-overlay-on');
                        $('#video-modal-container').html(res.html);
                        Videos.initHandlers();
                    }
                });
            }
            $('.video-overlay__close').click(function() {
                window.location.hash = hash_on_close;
                $('#video-modal-container').empty();
                $('.page').removeClass('video-overlay-on');
            });
            $(document).on('keydown', function(event) {
                if (event.key == 'Escape') {
                    window.location.hash = '';
                    $('#video-modal-container').empty();
                    $('.page').removeClass('video-overlay-on');
                }
            });
        }
    };
}();

//# sourceMappingURL=videos.js.map
